<template>
  <section>
    <slot>
      <router-view/>
    </slot>
  </section>
</template>